<template>
  <QuestionBody :qsNumber="qsNumber" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-4",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 4,
      navigateType: 'CLICK_ANY_BTN',
      content: {
        layout: 'layout_center',
        componentsType: {
          pc: 'cardBtn',
          mobile: 'longBtn'
        },
        mainTitle: 'Are you in any of the following states?',
        btn: [
          [
            {
              text: 'None',
              icon: require('@/assets/icon/questionIcon/7-None.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/7-None.png'),
              link: '/questionnaire/section2',
              operation: 'flag1-4 None & add reminder 23'
            },{
              text: 'Prepare for pregnancy',
              icon: require('@/assets/icon/questionIcon/Prepare_for_pregnancy.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/7-Prepare for pregnancy.png'),
              link: '/questionnaire/section1/5',
              operation: 'add reminder 1 & flag1-4 Prepare'
            },{
              text: 'Pregnancy',
              icon: require('@/assets/icon/questionIcon/Pregnancy.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/7-Pregnancy.png'),
              link: '/questionnaire/section1/10',
              operation: 'add product FM-PREVI-101 & flag1-4 Pregnancy & add reminder 22'
            }
          ],[
            {
              text: 'Lactation',
              icon: require('@/assets/icon/questionIcon/Lactation.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/7-Lactation.png'),
              link: '/questionnaire/section1/14',
              operation: 'add product FM-POSVI-101 & flag1-4 Lactation & add reminder 14'
            },{
              text: 'Menopause',
              icon: require('@/assets/icon/questionIcon/Menopause.png'),
              clickedIcon: require('@/assets/icon/clickedIcon/7-Menopause.png'),
              link: '/questionnaire/section1/18',
              operation: 'add product FM-DIM-101 & flag1-4 Menopause & add reminder 12'
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
